// extracted by mini-css-extract-plugin
export default {"grid":"finance-account_grid__acUfP"};